import styled from '@emotion/styled';
import { Indicator, Model } from '@gameonly/core';

import { IconContainer, scopeIcons } from './ResultsSimple';

import { useTranslation } from 'react-i18next';
import { TitleScoreContainer } from './ResultsSimple';
import keyify from '../project/parameters/keyify';

const IndicatorComponentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
`;

const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
`;

interface IndicatorProps {
  result: Indicator;
  modelName?: string;
}

const IndicatorComponent = ({ result, modelName }: IndicatorProps) => {
  const { t } = useTranslation(['project', 'model']);
  const icon = scopeIcons[result.code!] ?? (
    <img src="/action.png" alt="action" />
  );
  const translationPrefix = `model:${keyify(modelName)}.result.${
    result.code?.toLowerCase()
  }`;
  return (
    <IndicatorComponentContainer>
      <IconContainer>{icon}</IconContainer>
      <TitleScoreContainer>
        <p>{modelName ? t(`${translationPrefix}.title`) : result.title}</p>
      </TitleScoreContainer>
      <IndicatorWrapper>
        <p className="h5r">
          <b>{result.number || 0}</b>{' '}
          <span className="hzr">{modelName ? t(`${translationPrefix}.unit`) || '' : result.unit}</span>
        </p>
      </IndicatorWrapper>
    </IndicatorComponentContainer>
  );
};

export default IndicatorComponent;
